























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosDevice, MelosDeviceType } from '@/services/api.service';
import MelosInput from '@/components/MelosInput.vue';
import MelosButton from '@/components/MelosButton.vue';
import askarImage from '@/assets/askar.png';
import transmitterImage from '@/assets/transmitter.png';
import _ from 'lodash';

@Component({
  components: {
    MelosInput,
    MelosButton,
  },
})
export default class DeviceDetails extends Vue {
  private debouncedDeviceChangeHandler: any = _.debounce(this.updateDeviceData, 1000);

  private async mounted() {
    if (this.deviceData === undefined) {
      await this.fetchContent();
    }
  }

  private get deviceData(): MelosDevice {
    return this.$store.state.ownedDevices.find((device: MelosDevice) => {
      return device._id === this.$route.params.deviceId;
    });
  }

  private get deviceImage() {
    return this.isTransmitter ? transmitterImage : askarImage;
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private async fetchContent() {
    const ownedDevices = await this.$apiService.getDevices();
    this.$store.commit('setOwnedDevices', ownedDevices);
  }

  @Watch('deviceData.name')
  @Watch('deviceData.ip')
  @Watch('deviceData.device_id')
  @Watch('deviceData.type')
  private async handleDeviceUpdate() {
    return this.debouncedDeviceChangeHandler();
  }

  private async updateDeviceData() {
    if (this.deviceData !== undefined) {
      return this.$apiService.updateDevice(this.deviceData);
    }
  }

  private get isTransmitter(): boolean {
    return this.deviceData?.type === MelosDeviceType.TRANSMITTER;
  }

  private set isTransmitter(transmitter: boolean) {
    this.deviceData.type = transmitter ? MelosDeviceType.TRANSMITTER : MelosDeviceType.STANDALONE;
  }

  private get connectedToDevice(): boolean {
    return this.$store.state.connectedDevice === this.deviceData.device_id;
  }

  private connectToDevice() {
    this.$melosControllerService.connect(this.deviceData.ip || 'localhost', this.deviceData.device_id || '');
  }

  private disconnectFromDevice() {
    this.$melosControllerService.disconnect();
  }
}
